const imageBasePath =
  process.env.NODE_ENV === "development" ? `http://localhost:7011` : `https://api.menshopbd.com`;

// const imageBasePath = `https://api.sellmart.com.bd`;

export default imageBasePath;
